import { render, staticRenderFns } from "./OnReserveAffirmationBlock.vue?vue&type=template&id=2a469244&scoped=true"
import script from "./OnReserveAffirmationBlock.vue?vue&type=script&lang=js"
export * from "./OnReserveAffirmationBlock.vue?vue&type=script&lang=js"
import style0 from "./OnReserveAffirmationBlock.vue?vue&type=style&index=0&id=2a469244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a469244",
  null
  
)

export default component.exports